export default "__VITE_PUBLIC_ASSET__d0e4b533__"